import { useTranslation } from '@refinedev/core';
import { Breadcrumbs } from 'components/breadcrumbs';
import { useState } from 'react';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import ApiService from 'utills/ApiService';
import useWindowWidth from 'utills/InitWidthDevice';
import WPSOrgInformationFormDetail from '../formDetail';
import { FullScreenLoading } from 'components/fullScreenLoading';

const WPSOrganizationInformation = () => {
  const windowWidth = useWindowWidth();
  const { translate, getLocale } = useTranslation();
  const [organizationInfo, setOrganizationInfo] = useState(null as any);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState('');
  const [fetchData, setFetchData] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("USER");

    if (user) {
      const userData = JSON.parse(user);
      setToken(userData?.token);
    }
  }, []);

  useEffect(() => {
    if (token !== '') {
      const intervalFetchData = setInterval(() => {
        setFetchData(true);
        clearInterval(intervalFetchData);
      }, 100);
    }
  }, [token]);

  useEffect(() => {
    if (fetchData) {
      fetchOrganization();
    }
  }, [fetchData]);

  const fetchOrganization = async () => {
    setLoading(true);
    try {
      const result = await ApiService.get(`organization`, token);

      if (result) {
        setOrganizationInfo(result);
      }
    } catch (error: any) {
      // toast.error(error.message);
    }

    setLoading(false);
  };

  const breadcrumbItems = [
    {
      label: translate('organization'),
      href: ''
    },
    {
      label: translate('information'),
      href: ''
    }
  ];

  useEffect(() => {
    if (windowWidth && windowWidth < 1024) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [windowWidth]);


  return (
    <div className="w-full">
      <Breadcrumbs type="wps" breadcrumbItems={breadcrumbItems} />

      {
        organizationInfo &&
         <WPSOrgInformationFormDetail
            organizationInfo={organizationInfo}
            isMobile={isMobile}
            translate={translate} />
      }

      {
        loading &&
        <FullScreenLoading />
      }

    </div>
  )
};

export default WPSOrganizationInformation;